/**
 * Conversions entre les UNITÉS DE FIGURE et les unités d'affichage de la
 * boîte résolue, et l'aimantation à la grille — F17 de
 * `docs/produit/SPEC-REPRESENTATION-VISUELLE.md` (§6.9.3).
 *
 * Fonctions PURES, partagées client et serveur. Elles vivent ici, et non dans
 * un composant, pour une raison de fond : **l'aimantation a lieu côté client
 * et c'est la valeur aimantée qui est soumise**, donc le serveur juge
 * exactement ce que l'élève a vu. Les trois voies de saisie de G6 — le doigt,
 * les flèches du clavier, les deux champs de coordonnées — doivent produire
 * *exactement* la même réponse ; elles passent donc toutes par les mêmes
 * fonctions, ici, plutôt que par trois arrondis voisins.
 *
 * Repère d'affichage : origine en haut à gauche de la boîte, y VERS LE BAS
 * (convention SVG). Repère de figure : celui de l'énoncé, y vers le haut.
 * Les échelles x et y sont égales par construction (H8), d'où un seul
 * `parUnite` : sans cela le cercle de tolérance de G6 serait une ellipse et
 * mentirait sur ce qui est accepté.
 */
/** Un point de la boîte résolue → les unités de l'énoncé. */
export function versUnitesFigure(echelle, p) {
    return {
        x: (p.x - echelle.origineX) / echelle.parUnite,
        y: (echelle.origineY - p.y) / echelle.parUnite,
    };
}
/** Les unités de l'énoncé → un point de la boîte résolue. */
export function versAffichage(echelle, p) {
    return {
        x: echelle.origineX + p.x * echelle.parUnite,
        y: echelle.origineY - p.y * echelle.parUnite,
    };
}
/** Ramène un point dans le domaine. Un geste hors cadre n'est pas une réponse à revoir. */
export function borner(p, d) {
    return {
        x: Math.min(Math.max(p.x, d.xMin), d.xMax),
        y: Math.min(Math.max(p.y, d.yMin), d.yMax),
    };
}
/**
 * Arrondit une valeur au multiple de `pas` le plus proche, en repassant par un
 * entier : `Math.round(v / pas) * pas` laisse traîner des `0,30000000000000004`
 * que les trois voies de saisie n'arrondiraient pas au même endroit.
 */
export function auPas(valeur, pas) {
    if (!(pas > 0) || !Number.isFinite(valeur))
        return valeur;
    return Number((Math.round(valeur / pas) * pas).toFixed(6));
}
/**
 * **Aimantation à la GRILLE, jamais vers la solution** (§6.9.1). Le point se
 * pose aux croisements du quadrillage — ce qui aide la main — et jamais sur la
 * bonne réponse, ce qui donnerait l'énoncé et ferait chercher à tâtons.
 */
export function aimanterALaGrille(p, pas, domaine) {
    return borner({ x: auPas(p.x, pas.x), y: auPas(p.y, pas.y) }, domaine);
}
//# sourceMappingURL=coordonnees.js.map